module.exports = __webpack_public_path__ + "static/img/bt.547d255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/bt.png
// module id = 1MX6
// module chunks = 1